import { ReasonForJoiningLaborHack } from "src/types";
import { reasonsForJoiningLaborHackOptions } from "src/pages/trades/complete-profile/constants";
import {
	FormControl,
	FormErrorMessage,
	Input,
	Stack,
} from "@chakra-ui/react";
import CertificateIcon from "../assets/certificate-icon.png";

type ReasonsForJoiningProps = {
	selectedReasons: ReasonForJoiningLaborHack[];
	onToggleReason: (reason: ReasonForJoiningLaborHack) => void;
	otherText?: string;
	onOtherTextChange: (text: string) => void;
	otherTextTouched?: boolean;
};

export default function ReasonsForJoining({
	selectedReasons,
	onToggleReason,
	otherText,
	onOtherTextChange,
	otherTextTouched,
}: ReasonsForJoiningProps) {
	const showOtherInput = selectedReasons.includes(
		ReasonForJoiningLaborHack.OTHER
	);

	const otherTextInvalid = !!(
		otherTextTouched &&
		showOtherInput &&
		!otherText
	);

	return (
		<div className="overflow-y-scroll grid grid-cols-1 lg:grid-cols-2">
			<div className="hidden lg:block py-8">
				<div className="mb-8 bg-[#EDEDED] w-[72px] h-[72px] rounded-full flex items-center justify-center p-6">
					<img src={CertificateIcon} alt="Certificate Icon" />
				</div>
				<div className="flex flex-col w-[70%]">
					<h2 className="mb-2 text-xl lg:text-2xl font-medium text-[#121212] font-[AeonikPro]">
						Why are you joining LaborHack?
					</h2>
					<p className="text-lg lg:text-xl text-[#464646]">
						Select all that apply to you. This helps us tailor your experience.
					</p>
				</div>
			</div>
			<div className="border-l-[0] lg:border-l-[1px] border-[#E7E7E7] lg:pl-12 py-8 flex flex-col gap-6">
				<div className="flex flex-col gap-4">
					<label className="text-base lg:text-xl text-[#212121] font-medium lg:hidden">
						Why are you joining LaborHack?
					</label>
					<p className="text-sm lg:text-base text-[#464646] lg:hidden">
						Select all that apply to you.
					</p>
					<div className="flex flex-wrap gap-3">
						{reasonsForJoiningLaborHackOptions.map(({ label, value }) => {
							const isSelected = selectedReasons.includes(value);
							return (
								<button
									key={value}
									type="button"
									onClick={() => onToggleReason(value)}
									className={`
										px-4 py-3 rounded-full border text-sm lg:text-base font-medium
										transition-colors duration-150 cursor-pointer
										${
											isSelected
												? "bg-[#121212] text-white border-[#121212]"
												: "bg-white text-[#464646] border-[#D7D7D7] hover:border-[#121212]"
										}
									`}
								>
									{label}
								</button>
							);
						})}
					</div>
				</div>

				{showOtherInput && (
					<FormControl isInvalid={otherTextInvalid}>
						<div className="flex flex-col gap-4">
							<label
								htmlFor="reasonForJoiningLaborHackOtherText"
								className="text-base lg:text-xl text-[#212121] font-medium"
							>
								Please specify why you are joining LaborHack
							</label>
							<div className="flex flex-col gap-1">
								<Input
									value={otherText || ""}
									onChange={(e) => onOtherTextChange(e.target.value)}
									type="text"
									id="reasonForJoiningLaborHackOtherText"
									rounded={0}
									py={{
										base: 5,
										lg: 8,
									}}
									px={{
										base: 3,
										lg: 5,
									}}
									border={"1px solid #D7D7D7"}
								/>
								<FormErrorMessage>
									Please tell us why you are joining LaborHack
								</FormErrorMessage>
							</div>
						</div>
					</FormControl>
				)}

				<Stack w={"full"}>
					<p className="text-sm lg:text-base text-[#464646] lg:w-[75%]">
						By clicking on "Submit", you have agreed to our{" "}
						<span>
							<a
								href={`${process.env.REACT_APP_HOME_APP_URL}/terms`}
								target="_blank"
								rel="noreferrer"
								className=" !text-accent-500"
							>
								Terms and Conditions
							</a>
						</span>{" "}
						&{" "}
						<span>
							<a
								href={`${process.env.REACT_APP_HOME_APP_URL}/privacy`}
								target="_blank"
								rel="noreferrer"
								className=" !text-accent-500"
							>
								Privacy policy
							</a>
						</span>
					</p>
				</Stack>
			</div>
		</div>
	);
}
